/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ActivateJiraServerInput = {|
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type activateJiraServerMutationVariables = {|
  input: ActivateJiraServerInput
|};
export type activateJiraServerMutationResponse = {|
  +activateJiraServer: ?{|
    +company: ?{|
      +jiraServerConsumerKey: ?string,
      +jiraServerPublicRsaKey: ?string,
      +jiraServerState: ?string,
    |}
  |}
|};
export type activateJiraServerMutation = {|
  variables: activateJiraServerMutationVariables,
  response: activateJiraServerMutationResponse,
|};
*/


/*
mutation activateJiraServerMutation(
  $input: ActivateJiraServerInput!
) {
  activateJiraServer(input: $input) {
    company {
      jiraServerConsumerKey
      jiraServerPublicRsaKey
      jiraServerState
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "ActivateJiraServerInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraServerConsumerKey",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraServerPublicRsaKey",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraServerState",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "activateJiraServerMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ActivateJiraServerPayload",
        "kind": "LinkedField",
        "name": "activateJiraServer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "activateJiraServerMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ActivateJiraServerPayload",
        "kind": "LinkedField",
        "name": "activateJiraServer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "activateJiraServerMutation",
    "operationKind": "mutation",
    "text": "mutation activateJiraServerMutation(\n  $input: ActivateJiraServerInput!\n) {\n  activateJiraServer(input: $input) {\n    company {\n      jiraServerConsumerKey\n      jiraServerPublicRsaKey\n      jiraServerState\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4f2ff7c44a483956ed26e04245244453';

module.exports = node;
